package com.daytimegaming.ourdailyfinances.presentation.manageaccounts

import com.daytimegaming.ourdailyfinances.domain.model.PlaidItem
import com.daytimegaming.ourdailyfinances.domain.model.Account
import com.daytimegaming.ourdailyfinances.domain.model.RealEstateHolding

sealed class ManageAccountsScreenState {
    data object Loading : ManageAccountsScreenState()
    data class Error(val message: String) : ManageAccountsScreenState()
    data class Loaded(
        val items: List<PlaidItem>,
        val accounts: List<Account> = emptyList(),
        val realEstateHoldings: List<RealEstateHolding> = emptyList(),
        val unlinkingItemId: String? = null,
        val accountOrder: List<String> = emptyList(),
    ) : ManageAccountsScreenState()
}
